module.exports = "/Wow@2x-59c59111c737eaba2c3664fedee9dc7a.png";